module.exports = __webpack_public_path__ + "static/media/muted.2b5bb705.mp3";